/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   getQueryListingMinPrice
 */

import { MIN_FILTER_PRICE } from '@zcode-ui/filters'
import type { Filters } from '@zcode/state-type'
import { isNumber } from '@zcode/utils'

import { QUERY_PRICE_DELTA } from '../constants'

export const getQueryListingMinPrice = ({
  filters,
  price,
}: {
  filters: Partial<Filters> | undefined
  price: number | null | undefined
}) => {
  const filtersMinPriceIsValid =
    filters && isNumber(filters.minPrice) && filters.minPrice !== MIN_FILTER_PRICE

  if (isNumber(price)) {
    const entityMinPrice = Math.round(price * (1 - QUERY_PRICE_DELTA))

    return filtersMinPriceIsValid ? Math.min(entityMinPrice, filters.minPrice) : entityMinPrice
  } else if (filtersMinPriceIsValid) {
    return filters.minPrice
  }

  return null
}
